import React, { lazy } from "react";
import { useRoutes } from "react-router";
import Loadable from "../view/common/component/Loadable";

const MainLayout = Loadable(lazy(() => import('../layout/MainLayout')));
const Profile = Loadable(lazy(() => import('../view/common/Profile')));
const Messages = Loadable(lazy(() => import('../view/common/Messages')));
const Subscription = Loadable(lazy(() => import('../view/seller/Subscription')));
const Dashboard = Loadable(lazy(() => import('../view/Provider/Dashboard')));

const ProviderRoutes = () => {
  const list = {
    children: [
      { path: '/', element: <MainLayout> <Dashboard/> </MainLayout>},
      { path: '/profile', element: <MainLayout> <Profile /> </MainLayout> },
      { path: '/chat', element: <MainLayout> <Messages /> </MainLayout> },
      { path: '/subscription', element: <MainLayout> <Subscription /> </MainLayout> },
      { path: '*', element: <MainLayout> <Dashboard/> </MainLayout> }
    ],
  };

  return useRoutes([list]);
}


export default ProviderRoutes;